import { render } from "./EventEditForm.vue?vue&type=template&id=528396a6&scoped=true"
import script from "./EventEditForm.vue?vue&type=script&lang=js"
export * from "./EventEditForm.vue?vue&type=script&lang=js"

import "./EventEditForm.vue?vue&type=style&index=0&id=528396a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528396a6"]])

export default __exports__